<template>
    <modal
      name="toolsPopupModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="400px"
      height="auto"
    >
      <div class="v-modal profile_details_modal">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">Upload Documents</h2>
          <span  @click="$emit('handleClose')">
            <em class="material-icons">close</em>
          </span>
        </div>
  
        <form @submit.prevent data-vv-scope="toolsForm">
          <div class="form-container">
            <div class="vx-row">
              <div class="vx-col w-full">
                <div
                  class="form_group mb-5"
                  @click="
                    documents = [];
                    filesUploading = false;
                  "
                >
                <div v-if="filteredApprovalDocs && checkProperty(filteredApprovalDocs,'length') > 0">
                  <span class="primary-btn sm ml-auto" @click="redirectToDocsList()"> View all requests</span>
                </div>
                <div class="timeline-info" v-if="false">
                  <ul>
                    <li>
                  <p class="m-0" v-if="filteredApprovalDocs && checkProperty(filteredApprovalDocs,'length') > 0" >
                    <ul class="activities_doc_list">
                      <template v-for="(doc,indoc) in filteredApprovalDocs" >
                        <template v-if="checkProperty(doc, 'path')">
                          <li class="cursor-pointer">
                            <docmentType :title="checkProperty(doc, 'name')" :item="doc" />
                          </li>
                        </template>
                      </template>
                    </ul>
                  </p>
                  </li>
                  </ul>
                </div>
                  <label class="form_label">Approval Documents*</label>
                  <div class="vs-component relative mb-1">                  
                    <file-upload
                      :multiple="true"
                      :hideSelected="true"
                      v-model="documents"
                      class="file-upload-input file_upload justify-center"
                      name="documentsUpload"
                      :accept="allDocEntity"
                      @updateData="updateData"
                      
                     
                    >
                      <img
                        class="file-icon"
                        src="@/assets/images/main/file-upload.svg"
                      />
                      Upload<em v-if="premiumProcessing && false">*</em>
                    </file-upload>
                    <span class="loader" v-if="filesUploading"
                      ><img src="@/assets/images/main/loader.gif"
                    /></span>
                  </div>
                  <input  type="hidden" data-vv-as="Document" name="document"  v-model="selectedFiles" v-validate="'required'" />
                  <span v-if="errors.has('toolsForm.document')" class="text-danger text-sm">*Document
                    are required</span>
                  <ul
                    class="uploaded-list note_uploads"
                    v-if="checkProperty(selectedFiles, 'length') > 0"
                  >
                    <template v-for="(file, fileindex) in selectedFiles">
                      <vs-chip
                        type="button"
                        @click="removeFiles(fileindex)"
                        :key="fileindex"
                        v-if="file.status !== false"
                        closable
                        >{{ file.name }}
                      </vs-chip>
                    </template>
                  </ul>
                </div>
              </div>
            </div>
         
          </div>
          <div class="popup-footer relative">
            <vs-button
              color="dark"
              @click="$emit('handleClose')"
              class="cancel"
              type="filled"
              >Cancel</vs-button
            >
            <vs-button
              color="success"
              @click="submitForm()"
              class="save"
              type="filled"
              >Submit
            </vs-button>
          </div>        
        </form>
      </div>
    </modal>
  </template>
  <script>
  import { EyeIcon } from 'vue-feather-icons'
  import docType from "@/views/common/docType.vue"
  import Vue from 'vue';
  Vue.use( CKEditor );
  import CKEditor from '@ckeditor/ckeditor5-vue2';
  import fileUploadNote from "@/views/common/fileUploadNote.vue";
  import FileUpload from "@/views/FileUpload.vue";
  import docmentType from "@/views/common/docType.vue";
  import _ from "lodash";
  export default {
      components: {
      docType,
      EyeIcon,
      FileUpload,
      fileUploadNote,
      docmentType
    },
    methods: {
      redirectToDocsList(){
        this.$modal.hide("toolsPopupModal");
        this.$emit('handleClose');
        this.$router.push({ name: 'approval-documents'}).catch(err => { })
      },
      updateData(docs){
        this.selectedFiles = docs;
      },
      removeFiles(index){
        this.selectedFiles.splice(index ,1)
      },
      submitForm() {
        this.$validator.validateAll('toolsForm').then((result) => {
          if (result) {
            let postData={
              "items": [{
              "category": "approval_notice",
              "documents":this.selectedFiles
              }]
            }
            this.$store.dispatch("commonAction", {"data":postData ,"path":"/ai-tools/create-request"}).then((response)=>{
              this.selectedFiles = [];
              this.$modal.hide("toolsPopupModal");
              this.$emit('handleClose')
            }).catch((error)=>{

            })              
          }
        });
      },
      getDocuments() {
        let postData ={
        "filters": {},
        "page": 1,
        "perpage": 1000
      }
      let path = '/ai-tools/request-list';

      try{
        this.$store.dispatch("getList", {"data":postData ,"path":path}).then((response)=>{
        // && _.has(mainItem, 'category') && mainItem['category'] == 'approval_notice'
        let filteredApprovalDocs = [];
        if(_.has(response, 'list') && this.checkProperty(response, 'list') && this.checkProperty(response, 'list', 'length')>0){
          _.forEach(response['list'], (mainItem)=>{
            if(_.has(mainItem, 'documents') && mainItem['documents'] && mainItem['documents'].length > 0 && _.has(mainItem, 'category') && mainItem['category'] == 'approval_notice'  ){
              _.forEach(mainItem['documents'], (childItem)=>{
                if(_.has(childItem, 'path') && childItem['path'] && _.has(childItem, 'status') && childItem['status']){ 
                  let findObj = _.find(filteredApprovalDocs, {'path': childItem['path']});
                  if(!findObj){
                    filteredApprovalDocs.push(childItem)
                  }
                }
              })
            }
          })
        }
        this.selectedFiles = _.cloneDeep(filteredApprovalDocs);
        this.filteredApprovalDocs = _.cloneDeep(filteredApprovalDocs);
        this.$modal.show("toolsPopupModal");
        }).catch((error)=>{
          this.$modal.show("toolsPopupModal");
        })
      }catch(err){
        this.$modal.show("toolsPopupModal");
      }              
      },
    },
    mounted() {
      this.getDocuments()
    },
    data: () => ({
      documents:[],
      premiumProcessing:false,
      selectedFiles:[],
      filesUploading:false,
      filteredApprovalDocs:[],
    }),
    props: {
      
    },
  };
  </script>